export const EXECUTION_RETENTION_SECONDS_PER_DAY = 24 * 60 * 60;
export const MIN_EXECUTION_RETENTION_SECONDS =
  EXECUTION_RETENTION_SECONDS_PER_DAY;
export const DEFAULT_WORKFLOW_RETENTION_SECONDS =
  7 * EXECUTION_RETENTION_SECONDS_PER_DAY;
export const DEFAULT_NON_WORKFLOW_EXECUTION_RETENTION_SECONDS =
  365 * EXECUTION_RETENTION_SECONDS_PER_DAY;

// Ceiling for any customer retention choice; partition drops key off this, so
// no history row may outlive its partition's upper bound by more than this.
export const MAX_EXECUTION_RETENTION_SECONDS =
  366 * EXECUTION_RETENTION_SECONDS_PER_DAY;

export function runExpiry(
  createdAt: number,
  retentionSeconds?: number | null
): number {
  return (
    createdAt +
    (retentionSeconds ?? DEFAULT_NON_WORKFLOW_EXECUTION_RETENTION_SECONDS) *
      1000
  );
}

export function retentionSecondsFromRunExpiry(
  createdAt: number,
  expiresAt?: number | null
): number {
  return expiresAt == null
    ? DEFAULT_NON_WORKFLOW_EXECUTION_RETENTION_SECONDS
    : Math.min(
        Math.round((expiresAt - createdAt) / 1000),
        MAX_EXECUTION_RETENTION_SECONDS
      );
}
